<template>
  <div class="generalPage">
    <div class="isotopeGrid">

      <div class="section1">
        <div class="title_wrapper">
          <p class="title">
            預防曱甴小貼士
          </p>
          <p class="subTitle">
            內外兼備，雙管齊下
          </p>
        </div>
      </div>

      <div class="section2">
        <div class="generalWrapper">
          <h1>預防曱甴小貼士 </h1>
          <p>曱甴對於人類的家居具有強烈的入侵性，它們時刻設法進入家居，依靠食物、水和溫暖的地方生存。如果在家中看到一隻曱甴，表示可能有更多隱藏的曱甴在家居裡。要防止曱甴侵襲，先要有內外兼備的預防計劃。 請參考以下一些有用的貼士。</p>
          
          <h1>屋外</h1>
          <p>曱甴從外面來到家中是為了尋找食物，水和溫暖的地方。預防曱甴的第一步就是防止曱甴從外面入侵家居。</p>
          <p>以下這些貼士有助減低曱甴侵襲的機會：</p>
          <ul>
            <li>確保門窗之間沒有間隙及裂縫。</li>
            <li>保持露台乾爽。下雨後請清理積水。</li>
            <li>建議在排水口安裝篩網，減低曱甴進入的機會。</li>
          </ul>

          <h1>屋內</h1>
          <p>家居是曱甴理想的棲息地，因為這裡有它們需要的水、食物、溫暖和黑暗的空間讓它們隱藏，特別是廚房、浴室及客廳！要防止曱甴入侵，除了從屋外做好防備，家居清潔也很重要的。以下就是幾個防止曱甴入侵的小貼士：</p>

          <h1>廚房</h1>
          <ul>
            <li>曱甴會為了喝水而進入家中，所以家裡滴漏的水槽和流動的水會吸引曱甴。為防止曱甴進入，請立刻修理和抹乾這些區域。</li>
            <li>因為曱甴會被食物吸引，請將食物存放在玻璃、塑料或充分密封的容器中，以防止曱甴進入。</li>
            <li>雪櫃的頂部和底部都很溫暖，吸引需要溫暖的曱甴。所以，請定期清潔這些地方，尤其要掃走食物碎屑和抹走污跡。</li>
            <li>曱甴喜歡溫暖的地方，意味著火爐下可能是曱甴聚集和居留的地方。請經常擦拭這些地方，清走碎屑和積水。</li>
            <li>請使用有蓋垃圾桶及保持乾淨，並定期清理裡面的垃圾。</li>
            <li>所有抽屜，橫架和櫥櫃應排列整齊，如有損壞，請盡快修理，以確保曱甴不會有隱藏的地方。如有使用膠墊或紙墊，請保持平坦，以免曱甴隱藏在墊下。</li>
          </ul>

          <h1>浴室</h1>
          <ul>
            <li>請將濕毛巾和未乾透的牙刷妥善放好，以免吸引曱甴。</li>
            <li>請定期檢查潮濕的地方，如水槽的上方和下方、廁所後面和浴缸附近有否洩漏。 如有裂縫應立刻密封。</li>
          </ul>

          <h1>客廳</h1>
          <ul>
            <li>沙發和椅子附近可能有食物碎屑。請保持這些區域乾淨，檢查是否有昆蟲出沒。</li>
            <li>曱甴喜歡溫暖的地方，可能會聚集在電視機後或其他電子產品之間。請定期檢查，防止曱甴藏在裡面。</li>
            <li>曱甴經常藏在木材中，請先檢查所有木製家具後才帶回家中。</li>
          </ul>

          <h1>其他地方</h1>
          <p>防止曱甴進入不常見的地方，如廚房及浴室。 預防勝於治療，防止曱甴入侵的每一步都很重要。</p>
          <ul>
            <li>若果家中有植物，要多加留意，因為植物所發出的氣味可能會吸引曱甴進入家中。</li>
            <li>碎屑和剩餘的飲料是曱甴的最愛，使用過的食具器皿及垃圾筒附近，請保持清潔。</li>
            <li>曱甴會到處尋找食物，所以請將食物存放在密封的容器中，避免曱甴進食。</li>
            <li>建議使用良好的玻璃膠密封所有缺口和會導致漏水的裂縫。</li>
            <li>請定期掃地及清理廚房，以減少隱藏的食物殘渣和肉眼看不見的碎屑。</li>
            <li>請勿遺漏骯髒的碗碟和器具在水槽中，因為食物的氣味會吸引曱甴，誘使它們從排水位進入。</li>
            <li>請經常清潔枱面及櫃面以除去食物殘渣。</li>
          </ul>
        </div>
      </div>

      <div class="backbar_wrapper">
        <div class="backbar">
          <router-link :to="'/preventiontips/tips'">
            <img class="icon" src="../assets/icon-chevron.svg">
            <p>返回</p>
          </router-link>
        </div>
      </div>

    </div>
    <contact></contact>
    <henkel-footer></henkel-footer>
  </div>
</template>

<script>
export default {
  created () {
    window.document.title = '威滅Combat 速效藥餌'
    window.scrollTo(0, 0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../styles/_vars.sass"
@import "../styles/_isotopeGrid.sass"

.generalPage
  padding-top: $topMenu-height

</style>



// WEBPACK FOOTER //
// PTipsTipsRoach.vue?725f299a